import GSAP from 'gsap';
import Component from '@averyano/core/src/classes/Component';
import NodeEmitter from '../classes/NodeEmitter';

export default class Hamburger extends Component {
	constructor() {
		super({
			element: 'nav',
			elements: {
				menu: '.nav__menu',
				menuLines: '.nav__menu__line',
			},
		});

		this.isAnimating = false;
		this.isOpen = false;

		this.$on('resetState', this.resetState.bind(this));
	}

	create() {
		this.createAnimation();
		this.addEventListeners();
	}

	resetState() {
		if (this.isOpen) this.toggleState();
	}

	toggleState() {
		if (window.isFullscreen || this.isAnimating) return;

		this.isAnimating = true;
		this.isOpen = !this.isOpen;

		if (this.isOpen) {
			this.$emit('stopScroll');
			this.$emit('openMenu');
		} else if (!this.isOpen) {
			this.$emit('startScroll');
			this.$emit('closeMenu');
		}

		this.animateHamburger();
	}

	createAnimation() {
		this.tl = GSAP.timeline({
			paused: true,
		});

		this.tl.fromTo(
			this.elements.menuLines[0],
			{
				top: '35%',
				rotate: 0,
				backgroundColor: '#010101',
			},
			{
				rotate: 45,
				top: '50%',
				duration: 0.5,
				ease: 'out.power4',
				backgroundColor: '#ffffff',
			},
			0
		);

		this.tl.fromTo(
			this.elements.menuLines[1],
			{
				top: '65%',
				rotate: 0,
				backgroundColor: '#010101',
			},
			{
				rotate: -45,
				top: '50%',
				duration: 0.5,
				ease: 'out.power4',
				backgroundColor: '#ffffff',
			},
			0
		);
	}

	animateHamburger = () => (this.isOpen ? this.tl.play() : this.tl.reverse());

	addEventListeners() {
		this.elements.menu.addEventListener('click', this.toggleState.bind(this));
	}
}
